import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {fetchStatus, triggerInsta2Notification} from "../store/actions/proposalActions";

const Insta2 = () => {
    const [proposalNumber, setProposal] = useState("");
    const [instaEligible, setInstaEligible] = useState(false);
    const [triggerStatus, setTrigger] = useState(false);
    const [number, setNumber] = useState("");

    const dispatch = useDispatch();
    const searchItem = () => {
        setInstaEligible(false);
        setTrigger(false);
        dispatch(fetchStatus(proposalNumber, instaEligibleCheck));
    };

    const sendLink = () => {
        dispatch(triggerInsta2Notification(proposalNumber,triggered));
    };

    const triggered = (res) => {
        if(res.status === "OK") {
            setTrigger(true);
            setNumber(res.body?.number);
        }
    }

    const instaEligibleCheck = (res) => {
        setInstaEligible(res?.required);
    }
    const inputHandler = (e) => {
        setProposal( e.target.value);
        setInstaEligible(false);
        setTrigger(false);
    };


    return (
        <>
            <div className="downloads_comp logs_comp d2cPayment">
                {/* <h1>JSON request tracker</h1> */}
                <div>Enter proposal number</div>
                <div className="tabSelection">
                    <div className="input-fields-wrapper">
                        <input
                            onChange={(e) => inputHandler(e)}
                            value={proposalNumber}
                            className={`input-field`}
                            type="text"
                            placeholder="Enter Proposal Number"
                            name="proposal"
                        />
                    </div>
                    <button className="searchbt" onClick={searchItem}>
                        Search
                    </button>
                    {instaEligible &&
                        <div className="bg-box">
                            <button onClick={sendLink}>Send Link</button>
                            {triggerStatus && <div>WhatsApp notification is send on {number}</div>}
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default Insta2;
